import { render, staticRenderFns } from "./WelcomeShortUrl.vue?vue&type=template&id=4bb2fb36&scoped=true&"
import script from "./WelcomeShortUrl.vue?vue&type=script&lang=js&"
export * from "./WelcomeShortUrl.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeShortUrl.vue?vue&type=style&index=0&id=4bb2fb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2fb36",
  null
  
)

export default component.exports